import React from 'react';
import SelectField from './select-field';
import type { SelectOption } from './select-field';

interface MixedSelectFieldProps {
  value: string | undefined;
  isMixed: boolean;
  onChange: (value: string) => void;
  options: SelectOption[];
  /** Shown when value is undefined and the selection is not mixed. */
  fallback?: string;
}

const MIXED = '__mixed__';

/**
 * SelectField that renders a disabled "(mixed)" sentinel when a multi-selection
 * disagrees on the value, and swallows attempts to pick the sentinel.
 */
const MixedSelectField: React.FC<MixedSelectFieldProps> = ({ value, isMixed, onChange, options, fallback }) => {
  const opts = isMixed ? [{ value: MIXED, label: '(разное)', disabled: true }, ...options] : options;
  const display = isMixed ? MIXED : (value ?? fallback ?? '');
  return (
    <SelectField
      value={display}
      options={opts}
      onChange={(v) => {
        if (v !== MIXED) onChange(v);
      }}
    />
  );
};

export default MixedSelectField;
